import { VerificationResponse } from '../types/VerificationTypes';
import config from '../config/environment'

export class VerificationService {
  private static baseUrl = config.REACT_APP_API_BASE_URL;

  static async verifyCredential(credentialId: string): Promise<VerificationResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/api/credentials/verify/${credentialId}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Verification failed:', error);
      return {
        verified: false,
        error: 'Failed to verify credential'
      };
    }
  }
} 